// extracted by mini-css-extract-plugin
export var textInput = "_jq-0";